import React from 'react'
const Header = () => {
  return (
    <header className='col-12'>
        <div className='header'>
            <h1>Bienvenido al buscador de GIFS</h1>
        </div>
    </header>
  )
}

export default Header
